import Navbar from "../assets/Navbar";
import CardDesign from "../components/cardDesign";
import FooterSection from "assets/Footer";
import { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import useGetCataloguesWithAllItem from "hook/useGetCataloguesWithAllItem";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import TrendingProducts from "components/dashboardComponents/trendingProducts";
import useHorizontalScrollButtons from "../utils/useHorizontalScrollButtons";
import ScreenScrollToTop from "../components/ScreenScrollToTop";
import CardShimmer from "../components/shimmer/CardShimmer";
import NoDataView from "../components/noDataView";

const CategoryWiseData = () => {
  const { catalogueId } = useParams();
  const { subGroupedAllData, loading, error } =
    useGetCataloguesWithAllItem(catalogueId);

  const scrollRef = useRef(null);
  const leftBtnRef = useRef(null);
  const rightBtnRef = useRef(null);
  const { scroll } = useHorizontalScrollButtons({scrollRef, leftBtnRef, rightBtnRef, dependency: [subGroupedAllData],});

  const hasAnyItems = subGroupedAllData?.some((c) => c.items?.length > 0);

  return (
    <div className="bg-gray-100 flex flex-col min-h-[100dvh]">
      <Navbar />

      <div className="container mx-auto relative">
        {loading && (
            <CardShimmer count={8} />
        )}

        {!loading && !error && !hasAnyItems && (
            <NoDataView title="শীঘ্রই নতুন পণ্য যুক্ত করা হবে।"/>
        )}

        {!loading &&
          !error &&
          hasAnyItems &&
          subGroupedAllData.map((catalogue) => {
            if (!catalogue.subcatalogues?.length) return null;

            return (
              <div key={catalogue.catalogue_id} className="mb-5 mt-3">
                {/* Banner */}
                {catalogue.banner_image_path && (
                  <div className="md:px-0 px-4 w-full overflow-hidden aspect-[1000/231]">
                    <img
                      src={`https://backend.nuhababy.com/${catalogue.banner_image_path}`}
                      alt={catalogue.title}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-full object-contain"
                    />
                  </div>
                )}

                {/* Subcategories Section */}
                <div className="flex items-center justify-center w-full px-4 md:my-5 mt-3">
                  <span className="md:text-2xl text-xl md:font-bold font-extrabold text-black tracking-wide pt-3 pb-1">
                    SUB CATEGORIES
                  </span>
                </div>

                <div className="relative mx-4 my-3">
                    <button
                        ref={leftBtnRef}
                      onClick={() => scroll("left")}
                      className="absolute top-1/2 left-0 -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10 hover:bg-gray-200"
                    >
                      <FaChevronLeft />
                    </button>
                  <div
                    ref={scrollRef}
                    className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar scroll-smooth"
                    style={{
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; }`}</style>

                    {catalogue.subcatalogues.map((sub) => (
                      <div className="flex-shrink-0 xl:w-[200px] md:w-[140px] w-[100px] snap-center">
                        <div className="rounded-[10px] overflow-hidden md:mx-4 mx-2">
                          <Link
                            key={sub.subCatalogue_id}
                            to={`/subCategory/${sub.subCatalogue_id}`}
                          >
                            {/* <div className="flex-shrink-0 w-[100px] md:w-[140px] xl:w-[200px] snap-center mx-2 md:mx-4"> */}
                            <div className="md:mb-4 mt-4 mb-2 bg-white shadow-sm hover:shadow-xl transition-transform rounded-sm">
                              <img
                                src={`https://backend.nuhababy.com/${sub.image_path}`}
                                alt={sub.title}
                                className="w-full h-[80px] md:h-[110px] lg:h-[150px] object-cover"
                              />
                            </div>
                            <div className="pb-2">
                              <h3 className="text-center lg:text-base md:text-sm text-xs font-bold">
                                {sub.title}
                              </h3>
                            </div>
                            {/* </div> */}
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>

                    <button
                        ref={rightBtnRef}
                      onClick={() => scroll("right")}
                      className="absolute top-1/2 right-0 -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10 hover:bg-gray-200"
                    >
                      <FaChevronRight />
                    </button>
                </div>

                {/* All items sorted */}
                {catalogue.items?.length > 0 && (
                  <CardDesign likeData={catalogue.items} />
                )}
              </div>
            );
          })}
      </div>

      <TrendingProducts />
      <FooterSection />
      <ScreenScrollToTop />
    </div>
  );
};

export default CategoryWiseData;
